<template>
  <div class="stepper">
    <template v-for="(step, index) in steps">
      <div :key="'step-' + index" class="step" :class="{
        active: index === currentStep,
        completed: index < currentStep
      }">
        <div class="circle">
          <svg v-if="index < currentStep" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="25" height="25" fill="none" class="check">
            <path d="M10.0549 15.8804L17.8349 8.11035" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M6.16504 12L10.055 15.89" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <span>{{ step }}</span>
      </div>
      <div v-if="index < steps.length - 1" :key="'line-' + index" class="line"
        :class="{ completed: index < currentStep }"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "RegistroBikeStepper",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.stepper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding-top: 20px;
}

@media (min-width: 601px) {
  .stepper {
    max-width: 630px;
    margin: 0 auto;
  }
}

/* STEP */
.step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

/* 🔥 LINHA (aqui está o segredo) */
.step::before {
  content: "";
  position: absolute;
  top: 14px;
  left: -39%;
  width: calc(100% - 48px);
  /* 🔥 encurta a linha */
  height: 2px;
  background-color: #d9dee5;
  z-index: 1;
}

@media (max-width: 600px) {
  .step::before {
    left: -32%;
  }
}

/* remove linha do primeiro */
.step:first-child::before {
  display: none;
}

/* progresso (verde) */
.step.completed::before {
  background-color: #4FA935;
}

/* CÍRCULO */
.circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #d9dee5;
  border: 2px solid #d9dee5;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  z-index: 2;
}

/* TEXTO */
.step span {
  margin-top: 10px;
  font-size: 12px;
  color: #6b7a90;
  text-align: center;
}

/* ATIVO */

.step.active .circle {
  background-color: white;
  /* cria o "respiro" */
  border: 2px solid #4FA935;
}

.step.active .circle::after {
  content: "";
  width: 12px;
  height: 12px;
  background-color: #4FA935;
  border-radius: 50%;
}

.step.active span {
  color: #4FA935;
  font-weight: 500;
}

/* CONCLUÍDO */
.step.completed .circle {
  background-color: #4FA935;
  border-color: #4FA935;
}
</style>
